export const environment = {
  apiUrl: `${process.env.REACT_APP_API_URL}` || "http://localhost:4000/api",
  // Google OAuth 2.0 Web client id (SCRUM-706). Baked into the bundle at
  // build time by CRA, like every REACT_APP_* var — it is public by design
  // (the backend is what verifies the id_token against this same audience).
  googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID ?? "",
  posthogKey: process.env.REACT_APP_POSTHOG_KEY ?? "",
  posthogHost: process.env.REACT_APP_POSTHOG_HOST ?? "https://us.i.posthog.com",
};
